<template>
  <div>
    <CustomDropdown v-model="showDropdown" :align=" $is_mobile_view ? 'left' : 'right'">
      <template #trigger>
        <div class="px-2-5 py-2 d-flex align-items-center border-form rounded">
          <svg height="16" viewBox="0 0 15 27" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.44141 23.7188C11.4023 23.7188 14.7539 21.6562 14.7539 17.8945C14.7539 15 12.9023 13.2773 8.76562 12.2812L6.53906 11.7539C3.92578 11.1328 2.71875 10.043 2.71875 8.33203C2.71875 6.49219 4.46484 4.91016 7.42969 4.91016C9.85547 4.91016 11.5195 6.04688 12.1641 8.14453C12.3516 8.75391 12.75 9.07031 13.3359 9.07031C14.0273 9.07031 14.4141 8.625 14.4141 7.94531C14.4141 7.75781 14.3906 7.55859 14.332 7.34766C13.6289 4.64062 10.8867 2.83594 7.42969 2.83594C3.35156 2.83594 0.433594 5.13281 0.433594 8.47266C0.433594 11.2383 2.26172 12.9727 6.1875 13.9219L8.41406 14.4492C11.332 15.1523 12.4688 16.1602 12.4688 18.0586C12.4688 20.3203 10.6172 21.6445 7.46484 21.6445C4.65234 21.6445 2.8125 20.4609 2.25 18.2695C2.05078 17.6484 1.66406 17.332 1.07812 17.332C0.398438 17.332 0 17.7891 0 18.4805C0 18.6562 0.0234375 18.8555 0.0820312 19.0664C0.820312 22.0078 3.92578 23.7188 7.44141 23.7188ZM7.38281 26.543C7.875 26.543 8.27344 26.1445 8.27344 25.6523V0.972656C8.27344 0.480469 7.875 0.09375 7.38281 0.09375C6.89062 0.09375 6.50391 0.480469 6.50391 0.972656V25.6523C6.50391 26.1445 6.89062 26.543 7.38281 26.543Z" fill="#999999"/>
          </svg>
      
          <p class="mb-0 body-2-4 mx-2-5 flex-shrink-0"><span class="text-subcolor body-2-1">Budget</span><span class="d-none d-md-inline"> : {{ summaryPrice }}</span></p>
          
          <svg class="delay" :class="{'transform-180' : showDropdown}" width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.52769 8C6.7155 8 6.90325 7.92487 7.031 7.78212L12.8451 1.82535C12.9727 1.69765 13.0479 1.53239 13.0479 1.3446C13.0479 0.953987 12.7549 0.653519 12.3643 0.653519C12.1765 0.653519 12.0037 0.728637 11.876 0.848825L6.12205 6.7305H6.92581L1.17182 0.848825C1.05164 0.728637 0.878869 0.653519 0.683569 0.653519C0.292957 0.653519 0 0.953987 0 1.3446C0 1.53239 0.0751175 1.69765 0.202816 1.83286L6.01689 7.78212C6.15961 7.92487 6.33238 8 6.52769 8Z" fill="#999999" />
          </svg>        
        </div>
      </template>

      <template #content>
        <div class="p-3" style="width: 220px">
          <div class="w-100 mb-3" :key="inputWrapperKey">
            <div class="w-100 mb-3">
              <p class="body-3-1 mb-1">Minimum</p>
              <input-currency-v2 v-model="minPrice" />
            </div>
            <div class="w-100 mb-3">
              <p class="body-3-1 mb-1">Maximum</p>
              <input-currency-v2 v-model="maxPrice" />
            </div>
          </div>
          <p v-if="showErrorMaximum" class="mb-2 body-3 text-danger">Maximum price must greater than minimum price</p>
          <div class="w-100 d-flex align-items-center justify-content-end">
            <button v-if="showClearButton" type="button"
              class="button-primary box-shadow-none border-black font-bold bg-white text-dark px-4 py-2 text-12" @click="applyChanges(true)">Clear</button>
            <button type="button" class="button-primary px-4 py-2 text-12 ml-2" @click="applyChanges()">Apply</button>
          </div>
        </div>
      </template>
    </CustomDropdown>
  </div>
</template>

<script>
  import { mapGetters, mapMutations } from 'vuex';
  import CustomDropdown from '../../general/CustomDropdown.vue';

  export default {
    components:{
      CustomDropdown
    },
    data(){
      return{
        showDropdown: false,
        minPrice: 0,
        maxPrice: 0,
        showError: false,
        inputWrapperKey: 0
      }
    },
    computed:{
      ...mapGetters(['getBePrice']),
      summaryPrice(){
        const start = this.getBePrice[0];
        const end = this.getBePrice[1];
        
        if(start === 0 && end === 0) return 'All Price';

        if(start === 0){
          return `Up to ${this.$formatCurrency(end)}`
        }
        
        if(end === 0){
          return `Start from ${this.$formatCurrency(start)}`
        }

        return `${this.$formatCurrency(start)} - ${this.$formatCurrency(end)}`
      },
      showClearButton(){
        return this.minPrice > 0 || this.minPrice > 0;
      },
      showErrorMaximum(){
        if(!this.showError || this.maxPrice === 0) return false;
        if(this.maxPrice <= this.minPrice) return true;
        return false;
      }
    },
    watch:{
      showDropdown(){
        setTimeout(() => {
          this.minPrice = this.getBePrice[0];
          this.maxPrice = this.getBePrice[1];
          this.showError = false
          this.inputWrapperKey++
        }, 50);
      }
    },
    methods:{
      ...mapMutations(['setBePrice']),
      applyChanges(isClear = false){
        if(!isClear) this.showError = true;
        if(this.showErrorMaximum) return;
        const params = isClear ? [0,0] : [this.minPrice, this.maxPrice]
        this.setBePrice(params);
        this.$emit('apply');
        setTimeout(() => {
          this.showDropdown = false
        }, 50);
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/hotel/be/HotelRoomFilterPrice.vue